export function getTransportIcon(mode?: string, notes?: string): string {
  const text = `${mode || ''} ${notes || ''}`.toLowerCase();
  
  if (text.includes('flight') || text.includes('plane') || text.includes('air')) {
    return '✈️';
  }
  if (text.includes('train') || text.includes('rail')) {
    return '🚂';
  }
  if (text.includes('drive') || text.includes('car') || text.includes('bus')) {
    return '🚗';
  }
  if (text.includes('walk') || text.includes('hike')) {
    return '🚶';
  }
  if (text.includes('boat') || text.includes('ship') || text.includes('ferry')) {
    return '⛴️';
  }
  
  return '📍'; // Default location marker
}

